import React, { useEffect, useState, useRef } from 'react';
import './HrRoundForInterview.css';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import axios from 'axios';

const HrRoundForInterview = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [allProfiles, setAllProfiles] = useState([]);
    const [profileOptions, setProfileOptions] = useState([]);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [submittedProfiles, setSubmittedProfiles] = useState([]);

    const [ctcPackage, setCtcPackage] = useState('');
    const [hrComments, setHrComments] = useState('');
    const [offerLetter, setOfferLetter] = useState(null);
    const [jobOptions, setJobOptions] = useState([]);
    const [selectedJob, setSelectedJob] = useState(null);
    // Create a ref for the file input
    const fileInputRef = useRef(null);
    const [formErrors, setFormErrors] = useState({});
    const [isJobFocused, setIsJobFocused] = useState(false);
    const isJobLabelFloated = isJobFocused || !!selectedJob;
    const [isProfileFocused, setIsProfileFocused] = useState(false);
    const isProfileLabelFloated = isProfileFocused || !!selectedProfile;
    // Fetch profile list
    useEffect(() => {
        if (selectedJob) {
            axios.get(`${process.env.REACT_APP_API_BASE_URL}/feedback/job-approved/${selectedJob.value}`)
                .then(response => {
                    const filteredProfiles = response.data
                        .filter(profile => !submittedProfiles.includes(profile.profileId))
                        .map(profile => ({
                            value: profile,
                            label: `${profile.profileId} - ${profile.name}`
                        }));
                    setProfileOptions(filteredProfiles);
                })
                .catch(error => console.error('Error fetching profiles:', error));
        }
    }, [selectedJob, submittedProfiles]); // ✅ Add submittedProfiles to dependencies

// On component mount
useEffect(() => {
  const saved = localStorage.getItem('submittedProfiles');
  if (saved) {
    setSubmittedProfiles(JSON.parse(saved));
  }
}, []);




    useEffect(() => {
        if (allProfiles.length > 0) {
            const options = allProfiles.map(profile => ({
                value: profile,
                label: profile.profileId
            }));
            setProfileOptions(options);
        }
    }, [allProfiles]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/job-openings`)
            .then(response => {
                const jobs = response.data.map(job => ({
                    value: job.jobId,
                    label: `${job.jobId} - ${job.positionName}`,
                    job: job // 👈 keep full job object
                }));
                setJobOptions(jobs);
            })
            .catch(error => console.error('Error fetching job openings:', error));
    }, []);



    const handleProfileChange = (selectedOption) => {
        const fullLabel = selectedOption.label; // "4GP1004 - Tiru"
        const [profileId, name] = fullLabel.split(' - '); // ["4GP1004", "Tiru"]

        const updatedProfile = {
            ...selectedOption.value,
            profileId: profileId.trim(),
            name: name?.trim() || ''
        };

        setSelectedProfile(updatedProfile);
    };


    const handleFileChange = (e) => {
        setOfferLetter(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedProfile || !selectedDate || !offerLetter) {
            alert('Please fill all required fields');
            return;
        }

        // Prepare form data (for file upload, use FormData)
        const formData = new FormData();
        formData.append('profileId', selectedProfile.profileId || '');
        formData.append('name', selectedProfile.name || '');
        formData.append('jobId', selectedJob?.value || '');
        formData.append('positionName', selectedJob?.job?.positionName || '');

        formData.append('email', selectedProfile.email || '');
        formData.append('joining', selectedDate); // Format: yyyy-mm-dd
        formData.append('salary', ctcPackage);
        formData.append('hrComments', hrComments);
        formData.append('offerLetter', offerLetter); // Attach the file

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/hround`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            console.log('Form submitted successfully:', response.data);
            alert('Form submitted successfully');

            // ✅ Exclude submitted profile
            setSubmittedProfiles(prev => [...prev, selectedProfile.profileId]);

            // ✅ Reset form
            setSelectedProfile(null);
            setSelectedDate('');
            setCtcPackage('');
            setHrComments('');
            setOfferLetter(null);
            setSelectedJob(null);
            setProfileOptions([]);
setJobOptions([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Error submitting form');
        }

    };

    const isFormValid =
        selectedProfile &&
        selectedDate &&
        offerLetter;


    return (
        <div className='main-div-hr'>
            <h2 className='hr-name'>HR Round</h2>
            <form onSubmit={handleSubmit}>


                <div className="hr-input-label-content-select">
                    <label className={`hr-floating-label-select ${isJobLabelFloated ? 'label-float-select' : ''}`}><span className='label-text'>Job&nbsp;ID:</span></label>
                    <Select
                        options={jobOptions}
                        value={selectedJob}
                        onChange={(selected) => setSelectedJob(selected)}
                        placeholder=" "
                        onFocus={() => setIsJobFocused(true)}
                        onBlur={() => setIsJobFocused(false)}
                        classNamePrefix="react-select"
                    />
                </div>
                <div className="shortlist-input-label-content-select">
                    <label className={`shortlist-floating-label-select ${isProfileLabelFloated ? 'label-float-select' : ''}`}>Profile ID</label>
                    <Select
                        options={profileOptions}
                        placeholder=""
                        value={profileOptions.find(option => option.value.profileId === selectedProfile?.profileId) || null}
                        onFocus={() => setIsProfileFocused(true)}
                        onBlur={() => setIsProfileFocused(false)}
                        classNamePrefix="react-select"
                        onChange={handleProfileChange}
                    />

                </div>
                <div className={`hr ${formErrors.selectedProfile ? 'did-error-input' : ''}`}>

                    <input type="text"
                        value={selectedProfile?.email || ''}
                        readOnly
                        className="hr-input"
                        placeholder=' ' />

                    <label className="hr-label"><span className="required">*</span><span className='label-text'>Email:</span></label>
                </div>

                <div className={`hr ${formErrors.ctcPackage ? 'did-error-input' : ''}`}>

                    <input
                        type="text"
                        className="hr-input" placeholder=" "
                        value={ctcPackage}
                        onChange={(e) => {
                            // Only allow numbers and decimal points
                            const regex = /^[0-9\b]+$/; // allows only numbers
                            if (e.target.value === '' || regex.test(e.target.value)) {
                                setCtcPackage(e.target.value);
                            }
                        }}
                        required
                    />
                    <label className="hr-label">CTC&nbsp;Package</label>
                </div>


                <div className={`hr ${formErrors.selectedDate ? 'did-error-input' : ''}`}>

                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        min={new Date()} // sets today's date as the minimum
                        className="hr-input" placeholder=" "
                    />

                    <label className="hr-label">Joining&nbsp;Date</label>
                </div>

                <div className="hr-file">
                    <label><span className="required">*</span>Offer &nbsp;Letter</label>
                    <input
                        type="file"
                        onChange={handleFileChange}
                        ref={fileInputRef} // Attach the ref to the file input
                        required
                    />
                </div>

                <div className={`hr ${formErrors.hrComments ? 'did-error-input' : ''}`}>

                    <input
                        type="text"
                        className="hr-input" placeholder=" "
                        value={hrComments}
                        onChange={(e) => setHrComments(e.target.value)}
                    />
                    <label className="hr-label">HR&nbsp;Comments:</label>
                </div>

                <div className='hr-btn'>
                    <button className='sub-btn' type="submit" disabled={!isFormValid}>Submit</button>

                </div>
            </form>
        </div>
    );
};

export default HrRoundForInterview;